import React from 'react'
import { Component, LocaleCode } from '../types/component'
import { getLocalizedText } from '../utils/localization'
import { ComponentRenderer } from './ComponentRenderer'
import { cn } from '../lib/utils'

interface PricingProps {
  component: Component
  locale: LocaleCode
  storeId: string
  apiUrl: string
  style: React.CSSProperties
}

export function Pricing({ component, locale, storeId, apiUrl, style }: PricingProps) {
  const config = component.config as any

  const title = getLocalizedText(config.title, locale)
  const subtitle = getLocalizedText(config.subtitle, locale)
  const columns = config.columns || 3

  const gridColsMap = {
    2: 'md:grid-cols-2',
    3: 'md:grid-cols-3',
    4: 'md:grid-cols-4',
  }
  const gridCols = gridColsMap[columns as keyof typeof gridColsMap] || 'md:grid-cols-3'

  return (
    <div style={style} className="w-full">
      <div className="max-w-7xl mx-auto">
        {(title || subtitle) && (
          <div className="text-center mb-12">
            {title && (
              <h2 className="text-3xl font-bold mb-4" style={{ color: style.color }}>
                {title}
              </h2>
            )}
            {subtitle && (
              <p className="text-lg opacity-80" style={{ color: style.color }}>
                {subtitle}
              </p>
            )}
          </div>
        )}

        <div className={cn('grid grid-cols-1 gap-8', gridCols)}>
          {component.children?.map((child) => (
            <ComponentRenderer
              key={child.id}
              component={child}
              locale={locale}
              storeId={storeId}
              apiUrl={apiUrl}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
